export default __webpack_public_path__ + "static/media/05_gallery.8a97bde0.jpg";